import axios from "axios";

// Forçar uso da URL de produção para resolver o problema
const ENDPOINT = "https://apiebom.adisetoritapevi.com.br/api";

// Log para debug
console.log("API Endpoint:", ENDPOINT);
console.log("NODE_ENV:", process.env.NODE_ENV);
console.log("Variáveis de ambiente:");
console.log("- REACT_APP_SERVICE_URL_DEV:", process.env.REACT_APP_SERVICE_URL_DEV);
console.log("- REACT_APP_SERVICE_URL:", process.env.REACT_APP_SERVICE_URL);
console.log("ENDPOINT final:", ENDPOINT);

export const api = axios.create({
  baseURL: ENDPOINT,
});

// Interceptor para logs de erro
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error);
    console.error("Request URL:", error.config?.url);
    console.error("Base URL:", ENDPOINT);
    return Promise.reject(error);
  }
);
